/* eslint jsx-a11y/anchor-is-valid: "off" */
import React from 'react'
import { Nav } from 'react-bootstrap'
import AppsNav from './AppsNav'
import ProfileNav from './ProfileNav'
import PropTypes from 'prop-types'
import AdminNav from './AdminNav'

export default function RightNav({ admin }) {
  return (
    <Nav>
      { admin && <AdminNav /> }
      <AppsNav />
      <ProfileNav />
    </Nav>
  )
}

RightNav.propTypes = {
  admin: PropTypes.bool
}
